<template>
  <v-container class="d-flex align-center justify-center fill-height">
    <v-card class="pa-4" width="350">
      <v-card-title>
        <v-img src="@/assets/logo.png" alt="E-Photo Logo" max-height="60"></v-img>
      </v-card-title>
      <v-card-text>
        <v-form @submit.prevent="register" class="mt-4">
          <v-text-field v-model="username" label="Username" required></v-text-field>
          <v-text-field v-model="password" label="Password" type="password" required></v-text-field>
          <v-text-field v-model="confirmPassword" label="Confirm Password" type="password" required></v-text-field>
          <v-btn type="submit" color="primary" class="mb-4">Register</v-btn>
          <v-alert v-if="error" type="error">{{ error }}</v-alert>
          <v-alert v-if="message" type="success">{{ message }} <a style="color:white" href="/EPeople">Click here to login...</a></v-alert>
        </v-form>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import axios from 'axios';

export default {
  name: 'RegisterBlog',
  data() {
    return {
      username: '',
      password: '',
      confirmPassword: '',
      error: null,
      message: null,
    };
  },
  methods: {
    validatePassword(password) {
      const passwordRegex = /^(?=.*[A-Z])(?=.*[!@#$%^&*])(?=.{8,})/;
      return passwordRegex.test(password);
    },
    async register() {
      this.error = null; // Reset error before starting registration process
      this.message = null; // Reset message before starting registration process
      
      if (!this.username.endsWith('@e-photo.it')) {
        this.error = 'Registration is only allowed with e-photo.it domain';
        return;
      }
      
      if (this.password !== this.confirmPassword) {
        this.error = 'Passwords do not match';
        return;
      }
      
      if (!this.validatePassword(this.password)) {
        this.error = 'Password must be at least 8 characters long, contain at least one uppercase letter, and one special character.';
        return;
      }
      const localurl = window.location.origin;
      console.log(localurl)
      try {
        const response = await axios.post(process.env.VUE_APP_SERVER3 + '/register', {
          username: this.username,
          password: this.password,
          url: localurl + '/EPeople',
        });
        this.message = response.data.message;
      } catch (error) {
        this.error = 'Registration failed';
        console.error(error);
      }
    },
  },
};
</script>

<style scoped>
.fill-height {
  height: 100vh;
}
</style>
